export default{
    Submit:"Submit",
    Submitting:'Submitting',
    Uploading:"Uploading",
    Logging_in:"Logging in",
    Loading:"Loading",
    No_more:"No More",
    No_Data:"No Data",
    Pull_down:"Pull down to refresh...",
    Release_refresh:"Release to refresh...",
    Please_login:"Please log in",
    System_busy:"The system is busy, please try again later",
    Login_succeeded:"Login succeeded",
    Recharging:"Recharging",
    Purchasing:"Purchasing",
    Receiving:"Receiving",
    Activating:"Activating",
    Extracting:"Extracting",
    Opening:"Opening",
    Buying:"Buying",
    Not_connected:'Not connected to wallet',
    Buy:"Buy",

    login:"Login",
    first_login:"Set password for first login, please remember the password!",


    connect_wallet:"Connect Wallet",
    please_connect_wallet:"Please connect the wallet",
    Network_error:"Network connection error, please replace the network",
    wait_confirm:"Please wait for confirmation on the chain",

    Ethereum_Main:"Ethereum Main Network",
    Goerli_Test:"Goerli Test Network",
    Binance_Smart:"Binance Smart Chain",
    BSC_test:"BSC Test Network",

    enter_login_psw:"Please enter your login password",
    modified_success:'Successfully modified',
    twopsw_not_match:"The two new passwords entered do not match",
    Change_password:"Change password",
    Disconnect:"Disconnect",
    enter_old_password:"Please enter the original password",
    enter_new_password:"Please enter a new password",
    enter_Confirm_Password:"Please enter the new password again",
    Confirm:'Confirm',
    Cancel:"Cancel",

    authorize_first:"Please authorize first",

    home:"Home",

    Recharge:"Deposit",
    Withdraw:'Withdraw',
    Exchange:"Swap",
    transfer:"Transfer",
    Transfer_records:"Transfer records",
    Transfer_in:"Transfer in",
    Transfer_out:"Transfer out",
    wallet:"Wallet",

    Draw_cards:"Unbox",
    Work_card:"Work Card",
    Chance_card:"Chance Card",
    Explain:"Explain",

    Working:"Worker",
    trade_for:"Transfer records",
    Unemployed:"Unemployed",
    In_office:"In office",
    Financial_value:"Financial value:",
    job_hunt:"On duty",
    cede:"Transfer",
    Congratulations_receiving:"Congratulations on successfully receiving it",
    sure_job:"Are you confirmed to be on duty?",
    sure_transfer:"Are you sure to transfer out?",
    Successful_job:"Successfully on duty",
    enter_transfer_address:"Enter the transfer address",
    Transfer_successful:"Transfer Successful",

    Bank:"Bank",
    enter_extraction:"Enter quantity",
    enter_deposit:"Enter quantity",
    Extraction_successful:"Extraction successful",
    Deposit_successful:"Deposit successful",
    Deposit:"Deposit",
    Extract:"Extract",

    Internship:"Intern",
    not_active:"Not active",
    Activated:"Activated",
    give:"Give",
    invalid:"Invalid",
    activate:"Activate",
    Value:'Value:',
    Transfer_to:"Transfer_to:",
    day:"Day",
    enter_give:"Enter the transfer address",
    sure_Activate_earning:"Activate to start earning, are you sure to activate?",
    Activation_successful:"Activation successful",

    Received_successfully:"Received successfully",
    choose_payment:"Please choose a payment method",
    Payment_method:"Payment method",
    Entrepreneurship:"Chance",
    Ended:"Ended",
    y_invalid:"Invalid",
    Amount:"Amount",
    lifespan:"Lifespan:",
    cycle:"Cycle",
    From_end:"From thew end",
    Total_value:"Total value:",
    Total_revenue:"Total revenue:",
    Receive:"Receive",
    Price:"Price:",
    Yield_ratio:'Yield ratio:',
    Cycle1:"Cycle:",
    Activation_time:'Activation time:',
    End_time:'End time:',
    End_of_earnings:'End of earnings:',

    Master_disciple:"Guild",
    Today_earnings:"Today's earnings",
    TotalSY_performance:"Total revenue",
    Team_performance:"Guild level",
    Team_TeamPer:"Contribute",
    binding:"Binding",
    one_level:"One level",
    two_level:"Two level",
    Copy:"Copy",
    Invitation_link:"Invitation link:",
    enter_master:"Enter the referrer's address",
    Binding_successful:"Binding successful",
    My_Referrals:"My Referrals",


    Copied_successfully:"Copied successfully",
    copy_failed:"Copy failed",
    details:"Details",
    detailed:"Detailed",

    Blind_box:"Blind box",
    occupation:'Occupation:',
    see:"View",
    open:"Open",
    Open_box:"Open blind box",
    sure_Open_box:"Are you sure to open the blind box?",
    Congratulations_obtaining:"Congratulations",
    Introduction:'Introduction:',
    Recharge_Record:"Deposit record",
    Recharge1:'Deposit coins :',
    Exchange_record:"Exchange record",
    Enter_exchange:"Enter quantity",
    Exchange_rate:"Exchange Rate",
    exchange_range:"The exchange quantity is not within the range",

    Enter_recharge_quantity:"Enter quantity",
    recharge_not_range:"The amount of coins deposited is not within the range",
    recharge_base:"The deposit base is",

    Chance_card_draw:"Chance card draw",
    My_opportunity:"My opportunity card",
    Draw:'Draw',
    Draw_cards1:"Draw Cards",
    Card_Description:"Card Description:",
    profit:"Profit:",
    drawing_expenses:"Card drawing expenses",
    Confirm_extraction:",Confirm extraction?",

    Enter_buy_quantity:"Enter Buy quantity",
    buy_not_range:"The purchase quantity is not within the range",

    Withdraw_record:"Withdraw record",
    Withdrawal:"Withdraw coins:",
    Reason_refusal:'Reason for refusal:',

    Enter_transfer_Count:"Enter quantity",
    Transfer_address:"Transfer address",
    transfer_range:"The transfer quantity is not within the range",

    Withdraw1:"Withdraw coins",
    Enter_withdrawal_quantity:"Enter quantity",
    Service_Charge:'Service Charge:',
    withdrawal_range:"The Withdraw coins quantity is not within the range",

    reference:'Reference:',
    Extract_work_card:"Extract Work Cards",
    One_click_claim:"Receiving",
    Expiration_time:"Expiration time:",

    Transfer_time:"Transfer time:",
    buy_time:"Buy time:",
    To_be_purchased:"To be buy",
    Purchased:"Purchased",
    Yield_rate:"Yield rate:",
    Total_amount:'Total amount:',
    Unit_Price:"Unit Price:",
    Remaining_time:"Valid remaining time:",
    invest_cycle:"Invest cycle:",
    Daily_decreasing:"Daily decreasing:",
    Financial_IQ:"Financial IQ:",
}